module.exports = __webpack_public_path__ + "static/media/6.04ec3c2d.jpg";